(()=>{
const isBrown=value=>/bruin|brown/i.test(value||'');
const variants=card=>JSON.parse(card.querySelector('[data-gift-variants]').textContent);
function updateCard(card,color){
 const list=variants(card),colored=list.some(v=>/zwart|black|bruin|brown/i.test(v.title))&&list.length>1;
 const chosen=colored?list.find(v=>isBrown(v.title)===(color==='brown')):list[0];
 if(!chosen||!chosen.available){card.hidden=true;card.dataset.available='false';return;}
 card.hidden=false;card.dataset.available='true';card.dataset.price=chosen.price;
 card.querySelectorAll('[data-gift-link]').forEach(a=>a.href=chosen.url);
 card.querySelector('[data-gift-price]').textContent=chosen.money;
 const image=card.querySelector('img');image.src=chosen.image;image.srcset='';image.alt=card.querySelector('h3').textContent+' — '+chosen.title;
}
class GiftFinder extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;this.dataset.ready='true';
  this.addEventListener('change',()=>this.update());this.update();
  const details=this.closest('details');
  this.closest('section').querySelector('.ec-present-cta')?.addEventListener('click',()=>{details.open=true;});
  const open=()=>{if(location.hash==='#cadeaukeuze')details.open=true;};
  open();this.hashHandler=open;window.addEventListener('hashchange',open);
 }
 disconnectedCallback(){window.removeEventListener('hashchange',this.hashHandler);}
 update(){
  const occasion=this.querySelector('[data-gift-occasion]').value,business=occasion==='business';
  const budget=this.querySelector('[data-gift-budget]'),color=this.querySelector('[data-gift-color]');
  budget.disabled=business;color.disabled=business;
  this.querySelector('[data-gift-business]').hidden=!business;
  this.querySelector('[data-gift-consumer]').hidden=business;
  this.querySelector('[data-gift-color-note]').hidden=business;
  if(business)return;
  const cards=[...this.querySelectorAll('[data-gift-card]')];
  cards.forEach(c=>updateCard(c,color.value));
  let eligible=cards.filter(c=>c.dataset.available==='true'&&Number(c.dataset.price)<=Number(budget.value));
  const isBoard=c=>['ecocut-two','duurzame-snijplank'].includes(c.dataset.handle);
  if(occasion==='home'){
   const boards=eligible.filter(isBoard).sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   const sets=eligible.filter(c=>!isBoard(c)).sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   eligible=[boards[0],sets[0]].filter(Boolean);
  }else eligible=eligible.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price)).slice(0,2);
  cards.forEach(c=>c.hidden=!eligible.includes(c));
  const status=this.querySelector('[data-gift-status]');status.textContent=eligible.length?status.dataset.found:status.dataset.empty;
 }
}
class Related extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.update(this.dataset.color);
  this.handler=e=>{if(String(e.detail?.data?.productId)!==this.dataset.productId)return;this.update(e.detail?.resource?.title);};
  document.addEventListener('variant:update',this.handler);
 }
 disconnectedCallback(){document.removeEventListener('variant:update',this.handler);}
 update(title){this.querySelectorAll('[data-gift-card]').forEach(c=>updateCard(c,isBrown(title)?'brown':'black'));}
}
if(!customElements.get('ec-gift-finder'))customElements.define('ec-gift-finder',GiftFinder);
if(!customElements.get('ec-related-products'))customElements.define('ec-related-products',Related);
})();